import { Component, ChangeDetectionStrategy } from '@angular/core'

import { MatIcon } from '@angular/material/icon'
import { MatDialogRef } from '@angular/material/dialog'

import { ButtonComponent } from '../../../../../components/button/button.component'

@Component({
  selector: 'app-validation-error',
  standalone: true,
  imports: [MatIcon, ButtonComponent],
  templateUrl: './validation-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./validation-error.component.scss'],
})
export class ValidationErrorComponent {
  constructor(private dialogRef: MatDialogRef<ValidationErrorComponent>) {}

  close(): void {
    this.dialogRef.close()
  }
}
